// Posiziona la didascalia della preview in modo che la sua freccia punti
// SEMPRE alla foto, non a un punto fisso. Si ancora orizzontalmente al centro
// del soggetto e va SOPRA di esso se c'è spazio (freccia verso il basso),
// altrimenti SOTTO (freccia verso l'alto); se il soggetto riempie l'altezza
// resta sovrapposta in alto. Riceve i ratio in percentuale di computeHaloRect
// ({ leftPct, topPct, widthPct, heightPct }) e restituisce dove ancorarla.
const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const computeCaptionPlacement = (halo) => {
  const centerXPct = halo.leftPct + halo.widthPct / 2;
  const leftPct = clamp(centerXPct, 20, 80);
  const bottomOfSubjectPct = halo.topPct + halo.heightPct;

  // Spazio sopra il soggetto: didascalia sopra, freccia verso il basso.
  if (halo.topPct >= 22) {
    return { placement: 'above', leftPct, anchorPct: 100 - halo.topPct };
  }

  // Niente spazio sopra ma spazio sotto: didascalia sotto, freccia in su.
  if (bottomOfSubjectPct <= 78) {
    return { placement: 'below', leftPct, anchorPct: bottomOfSubjectPct };
  }

  // Soggetto molto grande: didascalia sovrapposta in alto, freccia in giù.
  return { placement: 'above', leftPct, anchorPct: 90 };
};
